import { api } from './api';
import {
  IntegrationAccess,
  IntegrationAccessNoteBody,
  IntegrationAccessScope,
  IntegrationProviderPasswordResponse,
  UpdateIntegrationPosBody,
} from '../types/api/integrationAccess.types';
import { ResponseType } from '../types/shared.types';

export const integrationAccessBase = (scope: IntegrationAccessScope) =>
  'incompleteLocationId' in scope
    ? `/v1/locations/incomplete/${scope.incompleteLocationId}/integration-access`
    : `/v1/locations/${scope.locationId}/integration-access`;

/*
 * Partner routes (owner of the location only). Every mutation answers with the whole
 * IntegrationAccess, the same object the GET returns, so the caller replaces its state.
 */

export const getIntegrationAccess = (scope: IntegrationAccessScope) =>
  api.get<ResponseType<IntegrationAccess>>(integrationAccessBase(scope));

export const updateIntegrationPos = (
  scope: IntegrationAccessScope,
  body: UpdateIntegrationPosBody
) =>
  api.put<ResponseType<IntegrationAccess>>(
    `${integrationAccessBase(scope)}/pos`,
    body
  );

export const grantIntegrationPos = (
  scope: IntegrationAccessScope,
  body: IntegrationAccessNoteBody
) =>
  api.post<ResponseType<IntegrationAccess>>(
    `${integrationAccessBase(scope)}/pos/grant`,
    body
  );

export const revokeIntegrationPos = (scope: IntegrationAccessScope) =>
  api.delete<ResponseType<IntegrationAccess>>(
    `${integrationAccessBase(scope)}/pos/grant`
  );

/** Selects one marketplace; calling it again for the same one changes nothing. */
export const selectIntegrationProvider = (
  scope: IntegrationAccessScope,
  menuProviderId: number
) =>
  api.post<ResponseType<IntegrationAccess>>(
    `${integrationAccessBase(scope)}/providers/${menuProviderId}`
  );

export const removeIntegrationProvider = (
  scope: IntegrationAccessScope,
  menuProviderId: number
) =>
  api.delete<ResponseType<IntegrationAccess>>(
    `${integrationAccessBase(scope)}/providers/${menuProviderId}`
  );

/** Selects the marketplace first if it was not selected yet. */
export const grantIntegrationProvider = (
  scope: IntegrationAccessScope,
  menuProviderId: number,
  body: IntegrationAccessNoteBody
) =>
  api.post<ResponseType<IntegrationAccess>>(
    `${integrationAccessBase(scope)}/providers/${menuProviderId}/grant`,
    body
  );

export const revokeIntegrationProvider = (
  scope: IntegrationAccessScope,
  menuProviderId: number
) =>
  api.delete<ResponseType<IntegrationAccess>>(
    `${integrationAccessBase(scope)}/providers/${menuProviderId}/grant`
  );

/*
 * Admin routes (admin, support). The list GET is the partner path with `password: null`;
 * the password has its own route because every reveal lands in the audit log, so it is
 * called on click, never on render.
 */

export const revealIntegrationProviderPassword = (
  locationId: number | string,
  menuProviderId: number
) =>
  api.get<ResponseType<IntegrationProviderPasswordResponse>>(
    `/v1/locations/${locationId}/integration-access/providers/${menuProviderId}/password`
  );
